import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { OptimizerComponent } from './optimizer/optimizer.component';
import { PrintComponent } from './print/print.component';
import { LoginComponent } from './login/login.component';

const routes: Routes = [
  {
    path: 'optimizer',
    component: OptimizerComponent
  },
  {
    path: 'print',
    component: PrintComponent
  },
  {
    path: 'login',
    component: LoginComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
